export default {
  editor: {
    current_template: 'Template',
    toolbar_title: 'Templates',
    use_button: 'Export HTML',
    save_button: 'Download HTML'
  },
  errors: {
    field: 'field',
    generic_error: 'Something went wrong',
    try_again: 'Try again',
    error_code: 'Logref:',
    missing_source: 'The Userdb associated to the template has been removed. You need to remove the association before executing the requested action.',
    '101906': 'The text\'s length must be between 1 and 255',
    '100000': 'Duplicated customer',
    '100002': 'Invalid customer',
    '600000': 'Error',
    '101802': 'Unauthorized user',
    '101803': 'Insufficient premissions',
    '101904': 'Validation error',
    '101905': 'The field must be alphanumeric',
    '101907': 'TemplateModel must be valid JSON',
    '101908': 'MergeTagSource id must be SEND',
    '101909': 'Field cannot be null',
    '101910': 'Field cannot be empty',
    '102000': 'Customer not found',
    '300100': 'Template not found',
    '300102': 'Duplicated template',
    '300103': 'Thumbnail not found',
    '3000104': 'Template cannot have a mergeTagsSource',
    '3000105': 'Shared property cannot be null',
    '400100': 'Merge tag source not found',
    '4000102': 'Merge Tags Source\'s type not valid',
    '400103': 'Merge tag source not found',
    '400104': 'Mapped Merge tag source not found',
    '500100': 'Invalid Display condition',
    '500102': 'Duplicated Display condition',
    '500103': 'Display Condition not found',
    '500105': 'Too many Display Conditions for this source. You cannot create more than 50 Display Conditions.',
    '700100': 'Invalid merge content',
    '700101': 'The external source does not exist',
    '700102': 'The view does not exist',
    '700103': 'The external source field does not exist or is not searchable',
    '700104': 'Duplicate Merge Content name',
    '800100': 'Duplicate category name',
  },
  libraries: {
    MINE: 'My Templates',
    CUSTOM: 'Custom Templates',
    PRESET: 'Default Templates',
    SHARED: 'Shared Templates',
    empty_library_heading: 'There\'s nothing here but me!',
    empty_library_first_line: 'You don\'t have any templates',
    empty_library_second_line: 'Create one or pick one from the Defaults'
  },
  modals: {
    cancel_button: 'Cancel',
    continue_button: 'Continue',
    name_exists: 'A template named {propName} already exists',
    open_selected_template: 'Open the selected template',
    overwrite_button: 'Overwrite',
    save_button: 'Save',
    save_into_library: 'Save in',
    duplicate_button: 'Duplicate',
    success_message: 'Action done',
    share_custom_message: 'The template is now shared with any sub-companies. If the company does not have sub-companies, sharing has no effect. The template will be automatically shared with any sub-companies when they are created.',
    template_not_saved: 'Template {propName} has not been saved.',
    unsaved_work: 'If you open a new template you\'ll lose your unsaved changes.',
    use_template: 'Warning: using the template without saving it you could lose any unsaved work',
    confirm_use: 'Continue',
    template_name: 'Template name',
    delete_template: 'Do you want to delete {propName} template ?',
    duplicate_description: 'The new template will be saved in My Library with the name:',
    close_button: 'Close',
    share_button: 'Share',
    unshare_button: 'Stop sharing',
    share_template: 'Do you want to share {propName} template?',
    unshare_template: 'Do you want to stop sharing {propName} template?',
    invalid_template_for_library: 'You cannot save a template associated to a userdb in default/custom library',
    select_page: 'Choose the page you want to go to',
    jump_page: 'Go to page',
    download: 'The template {propName} could have been modified, the last saved version will be downloaded',
    download_button: 'Download',
    row_category_exists: 'A category named {propName} already exists',
  },
  template: {
    use: 'Use',
    rename: 'Rename',
    copy: 'Duplicate',
    delete: 'Delete',
    share: 'Share',
    unshare: 'Stop Sharing',
    share_label: 'shared',
    download: 'Download'
  },
  toolbar: {
    back_to_work: 'Go back to work on',
    current_template: 'Template',
    start_from_scratch: 'Start from scratch',
    title: 'Templates',
    search: 'Search',
    placeholder_search: 'Search by template name'
  },
  filters: {
    date_locale: 'en-EN',
    button_label: 'Filters Conditions',
    add_filter: 'Add a new filter',
    empty_list: 'No filter conditions found',
    list_name: 'Filter name',
    list_created: 'Created',
    list_actions: 'Actions',
    must_satisfy: 'My filter must satisfy',
    all_conditions: 'All conditions (AND)',
    one_of_conditions: 'At least one of these conditions (OR)',
    name: 'Name',
    name_error: 'The filter\'s name is required',
    type_error: 'The filter\'s type is requierd',
    field: 'Field',
    operator: 'Operator',
    value: 'Value',
    back: 'Back to filter list',
    apply: 'Apply without saving',
    EQ: 'equals to',
    NOT_EQ: 'different from',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'not contains',
    GT: 'greater than',
    LT: 'less than',
    EMPTY: 'empty',
    NOT_EMPTY: 'not empty',
    NULL: 'null',
    NOT_NULL: 'not null',
    duplicate_error: 'A filter with the same name already exists',
    save: 'Save',
    save_as_new: 'Save as new filter',
    confirm_delete: 'Are you sure to remove {propName} filter?',
    confirm_delete_yes: 'Yes',
    confirm_delete_no: 'No'
  },
  tags: {
    button_open_modal: 'Manage Tags',
    template_tags_limitation_msg: 'You can choose a maximum of 3 tags',
    tags_limitation_msg: 'There must be a maximum of 50 tags and each of them must be a maximum of 10 characters. Only alphanumeric characters plus the minus (-) and underscore (_) characters are allowed.',
    invalid_tag_msg: 'Each tag must be a maximum of 10 characters and only alphanumeric characters plus the minus (-) and underscore (_) characters are allowed.',
    placeholder_add_tag: 'Add tag',
    search_by: 'Search by tags',
    select_label: 'Press enter to select',
    selected_label: 'Selected',
    deselect_label: 'Press enter to remove',
    max_message: 'Maximum of 3 tags selected. First remove a selected tag to select another.',
    not_found_message: 'No elements found. Consider changing the search query.',
    no_options: 'List is empty.',
    add_tags: 'Add tags',
    create_tag: 'Press enter to create a tag',
    invalid_tag: 'The tag {propName} is invalid',
    delete_tags: 'You are about to delete one or more tags, any associations with templates will be removed.'
  },
  content: {
    dynamic_contents: 'Dynamic contents',
    dynamic_contents_alert: 'Send highly targeted and personalised e-mails to each recipient: more details ',
    add_content_btn: 'Add dynamic content',
    back_link: 'Back to Dynamic content List',
    form_title: 'Dynamic content details',
    structure_title: 'DEFINE THE STRUCTURE',
    name: 'Dynamic content name',
    source: 'External Source',
    view: 'View',
    rule: 'RULE',
    searchable_field: 'External source field',
    operation: 'Operator',
    value: 'Value',
    content: 'UserDB',
    field: 'Field',
    static_field: 'Use constant value',
    dynamic_field: 'Use UserDB Field',
    save: 'Save',
    equal: 'Equal to',
    content_name_error: 'Please input dynamic content name!',
    source_error: 'Please select an external source!',
    view_error: 'Please select a view!',
    field_error: 'Please select a field!',
    value_error: 'Please insert a value!',
    userdb_error: 'Please select a userDb!',
    userdb_field_error: 'Please select a field!',
    saved_content_title: 'Content saved',
    saved_content_message: 'Content { name } saved',
    contents_error_title: 'Cannot retrieve Dynamic Contents',
    contents_extra_info_error_title: 'Cannot retrieve some extra info',
    userdb_error_title: 'Cannot retrieve userDbs',
    userdb_fields_error_title: 'Cannot retrieve userDb fields',
    sources_error_title: 'Cannot retrieve external sources',
    content_save_error: 'Cannot save merge content',
    load_source_info_error: 'Hasn\'t been possible to retrieve external source or searchable fields',
    field_not_found: 'Searchable field not found',
    view_not_found: 'View not found',
    source_not_found: 'External source not found',
    merge_tag_source_info_error: 'Hasn\'t been possible to retrieve content iformation',
    delete_content_title: 'Delete dynamic content',
    delete_content: 'Delete {propName}?',
    delete_content_error: 'Cannot delete dynamic content',
    create_content_title: 'Create new Dynamic Content'
  },
  row_categories: {
    container_title: 'Manage Categories',
    empty_list: 'No row categories found',
    back: 'Back to the categories list',
    add_category: 'Add Category',
    list_name: 'Category',
    list_actions: 'Actions',
    name: 'Category Name',
    name_empty: 'The category\'s name is required',
    save: 'Save',
    save_as_new: 'Save New Category',
    confirm_delete: 'Are you sure to remove category {propName}?',
    confirm_delete_warning: 'Warning: all rows belonging to the category will be deleted',
    confirm_delete_yes: 'Yes',
    confirm_delete_no: 'No',
    select_label: 'Press enter to select',
    selected_label: 'Selected',
    deselect_label: 'Press enter to remove',
    create_category_label: 'Press enter to create a new category',
  },
  saved_rows: {
    container_title: 'Save Row',
    container_title_edit: 'Edit Row',
    container_subtitle: 'Save this row to your library to use it in the future.',
    container_subtitle_edit: 'Edit the details of your row.',
    category: 'Category',
    name: 'Row Name',
    name_empty: 'The row\'s name is required',
    save: 'Save',
    category_empty: 'The category\'s is required',
    no_categories_found: 'No categories found',
    only_one_category: 'You can select only one category',
    save_as_new: 'Save as new',
    update: 'Update'
  },
  general: {
    name: 'Name',
    version_date: 'Last Update',
    version_by: 'User',
    database: 'UserDB',
    delete: 'Delete',
    edit: 'Edit',
    here: 'here'
  },
  test: {
    title: 'Send test',
    subject: 'Subject',
    sender: 'Sender',
    mail_from: 'Mail From',
    reply_to: 'Reply To',
    recipient: 'Recipient',
    duplicate_recipient_error: 'The recipient is already present.',
    max_recipient_error: 'Cannot add any more recipients.',
    duplicate_merge_tag_error: 'The Merge Tag is already present.',
    empty_subject_error: 'The subject field is mandatory.',
    empty_sender_error: 'The sender field is mandatory.',
    empty_mail_from_error: 'The mail from field is mandatory.',
    empty_reply_to_error: 'The reply to field is mandatory.',
    empty_recipients_error: 'At least one recipient must be specified.',
    missing_immediate_error: 'You have to configure an immediate delivery with alias',
    missing_immediate_alias: '"Email-Designer-Test-Delivery".',
    missing_immediate_link_name: 'Click here',
    missing_immediate_link: 'https://docs.contactlab.com/docs/guides/send/create/email-delivery/immediate-message',
    missing_immediate_error_after: 'to know more.',
    missing_template_errror: 'Warning: you are editing a new template, you must first save it to send a test email.',
    test_sent: 'Test message {propName} sent.',
    invalid_email_address: 'Invalid email address.',
    send: 'Send'
  },
  validation_errors: {
    '101417': 'The sender field is mandatory.',
    '101418': 'You reached the maximum number of recipients.',
    '101419': 'You reached the maximum number of attachments.',
    '101427': 'The specified attachment\'s type is not valid.',
    '101428': 'Recipient\'s email address is not valid.',
    '101429': 'CC Recipient\'s email address is not valid.',
    '101430': 'BCC Recipient\'s email address is not valid.',
    '101431': 'Message body cannot be empty.',
    '101432': 'The subject field is mandatory.',
    '101433': 'The sender email address is mandatory.',
    '101434': 'The sender field is mandatory.',
    '101435': 'The \'reply to\' field is mandatory',
    '101436': 'The sender email address is not valid.',
    '101437': 'Attachment\'s name is mandatory.',
    '101438': 'Attachment\'s type is mandatory.',
    '101439': 'Attachment cannot be empty.',
    '101441': 'Total size of attachments exceeds the limit.',
    '101444': 'The \'reply to\' email address is not valid.'
  }
};
